import { formatISO } from 'date-fns';
import { baseQuery } from '../baseQuery';
import type { ServiceProduct, WithoutTimestamps } from 'types';

type ServiceProductsPayload = WithoutTimestamps<
  Omit<Partial<ServiceProduct> & { productId: ServiceProduct['productId'] }, 'product'>
>;

export async function patchServiceProducts(serviceId: string | number, products: ServiceProductsPayload[]) {
  return await baseQuery(`services/${serviceId}/products`, {
    type: 'PATCH',
    body: {
      data: products.map((product) => ({
        ...product,
        completionDate: product.completionDate instanceof Date ? formatISO(product.completionDate) : null,
      })),
    },
  });
}
